import { MARKET as d, MARKETS_FOR_POSTAL_CODE as o } from "@smart/types";
const r = {
  AT: /^(AT)(U\d{8}$)/,
  // Austria
  BE: /^(BE)(\d{10}$)/,
  // Belgium
  BG: /^(BG)(\d{9,10}$)/,
  // Bulgaria
  CY: /^(CY)(\d{8}[A-Z]{1}$)/,
  // Cyprus
  CZ: /^(CZ)(\d{8,10})?$/,
  // Czech Republic
  DE: /^(DE)(\d{9}$)/,
  // Germany
  DK: /^(DK)(\d{8}$)/,
  // Denmark
  EE: /^(EE)(\d{9}$)/,
  // Estonia
  EL: /^(EL)(\d{9}$)/,
  // Greece
  ES: /^(ES)([0-9A-Z][0-9]{7}[0-9A-Z]$)/,
  // Spain
  EU: /^(EU)(\d{9}$)/,
  // EU-type
  FI: /^(FI)(\d{8}$)/,
  // Finland
  FR: /^(FR)([0-9A-Z]{2}[0-9]{9}$)/,
  // France
  GR: /^(GR)(\d{8,9}$)/,
  // Greece
  HR: /^(HR)(\d{11}$)/,
  // Croatia
  HU: /^(HU)(\d{8}$)/,
  // Hungary
  IE: /^(IE)([0-9A-Z\*\+]{7}[A-Z]{1,2}$)/,
  // Ireland
  IT: /^(IT)(\d{11}$)/,
  // Italy
  LV: /^(LV)(\d{11}$)/,
  // Latvia
  LT: /^(LT)(\d{9}$|\d{12}$)/,
  // Lithunia
  LU: /^(LU)(\d{8}$)/,
  // Luxembourg
  MT: /^(MT)(\d{8}$)/,
  // Malta
  NL: /^(NL)(\d{9}B\d{2}$)/,
  // Netherlands
  PL: /^(PL)(\d{10}$)/,
  // Poland
  PT: /^(PT)(\d{9}$)/,
  // Portugal
  RO: /^(RO)(\d{2,10}$)/,
  // Romania
  SI: /^(SI)(\d{8}$)/,
  // Slovenia
  SK: /^(SK)(\d{10}$)/,
  // Slovakia Republic
  SE: /^(SE)(\d{12}$)/
  // Sweden
}, n = {
  CH: /^(CH)(E\d{9}(MWST|TVA|IVA)$)/,
  // Switzerland - CHE + 9 digits + MWST/TVA/IVA
  GB: /^(GB)(\d{9}$)/,
  // United Kingdom (Great Britain) - GB + 9 digits
  IS: /^(IS)([0-9A-Z]{5,6}$)/,
  // Iceland - IS + 5-6 digits/letters
  NO: /^(NO)(\d{9}MVA$)/,
  // Norway - NO + 9 digits + MVA
  SM: /^(SM)(\d{5}$)/
  // San Marino - SM + 5 digits
}, E = {
  AT: /^(?:([0-9]{9})|([0-9]{11}))$/,
  // Austria - 9/10 digits
  BE: /^(\d{10,13})$/,
  // Belgium - 10-13 digits
  BG: /^(?:([0-9]{10})|([0-9]{12}))$/,
  // Bulgaria - 10/12 digits
  CY: /^(?:([0-9]{9})|([0-9]{11}))$/,
  // Cyprus - 9/11 digits
  CZ: /^(?:([0-9]{8})|([0-9]{10})|([0-9]{12}))$/,
  // Czech Republic - 8/10/12 digits
  DE: /^(?:([0-9]{11})|([0-9]{13}))$/,
  // Germany - 11/13 digits
  DK: /^(?:([0-9]{8})|([0-9]{10})|([0-9]{12}))$/,
  // Denmark - 8/10/12 digits
  ES: /^(?:([0-9]{9})|([0-9]{11}))$/,
  // Estonia - 9/11 digits
  FI: /^(?:([0-9]{8})|([0-9]{10})|([0-9]{11})|([0-9]{13}))$/,
  // Finland - 8/10/11/13 digits
  FR: /^(?:([0-9]{9})|([0-9]{13}))$/,
  // France - 9/13 digits
  HR: /^(?:([0-9]{11})|([0-9]{13}))$/,
  // Croatia - 11/13 digits
  HU: /^(\d{10,13})$/,
  // Hungary - 10-13 digits
  IR: /^(\d{8,11})$/,
  // Ireland - 8-11 digits
  IT: /^(?:([0-9]{11})|([0-9]{13}))$/,
  // Italy - 11/13 digits
  NL: /^(?:([0-9]{12})|([0-9]{14}))$/,
  // Netherlands - 12/14 digits
  PL: /^(?:([0-9]{10})|([0-9]{12}))$/,
  // Poland - 10/12 digits
  PT: /^(?:([0-9]{9})|([0-9]{11}))$/,
  // Portugal - 9/11 digits
  RO: /^(?:([0-9]{2,12})|([0-9]{13})|([0-9]{15}))$/,
  // Romania - 2-12/13/15 digits
  SE: /^(?:([0-9]{10})|([0-9]{12}))$/
  // Sweden - 10/12 digits
}, A = /^(\d{2,15})$/, c = {
  GB: /^(\d{10})$/
  // United Kingdom (Great Britain)
}, T = (t, s) => Object.values(s).some((a) => a.test(t)), i = (t, s = "", a) => {
  const $ = t.toUpperCase();
  if ($ === d.IT)
    return /^([A-Z0-9]{16}$)/.test(s);
  if ($ === d.SE)
    return /^([0-9]{12})$/.test(s);
  if ($ === d.DE) {
    const e = r.DE.test(s) || E.DE.test(s);
    return !e && a ? T(s, r) || A.test(s) : e;
  }
  if ($ === d.GB) {
    const e = n.GB.test(s);
    return e || c.GB.test(s);
  }
  return /^([A-Z0-9]{9})$/.test(s);
}, u = (t, s) => s === "" ? !1 : S(t).test(s), S = (t) => {
  const s = t.toUpperCase();
  if (!o.includes(s))
    return /.*/;
  switch (s) {
    case "AT":
    case "BE":
    case "CH":
      return /^\d{4}$/;
    case "ES":
    case "FR":
    case "DE":
    case "IT":
      return /^\d{5}$/;
    case "IS":
      return /^\d{3}$/;
    case "NL":
      return /^[1-9]\d{3}\s(?!ss|sa|sd)[a-z]{2}$/i;
    case "PT":
      return /^\d{4}[-]\d{3}$/;
    case "GB":
      return /^((?:[A-Z]{1,2}[0-9][A-Z0-9]?|[A-Z]{2}[0-9] [0-9][A-Z]{2}|[A-Z][0-9] [0-9][A-Z]{2}|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?[0-9][A-Z]{2}|BFPO ?[0-9]{1,4}|(?:KY[0-9]|MSR|VG|AI)[ -]?[0-9]{4}|[A-Z]{2} ?[0-9]{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$/i;
    case "SE":
      return /^\d{3}[ ]\d{2}$/;
    case "NO":
      return /^[0-9]{4}$/;
  }
}, C = (t, s) => ({
  statusCode: 400,
  headers: { "X-Lambda-Request-Id": t },
  body: JSON.stringify(s.format())
});
export {
  E as a,
  A as b,
  c,
  u as d,
  r as e,
  S as g,
  n,
  T as t,
  i as v,
  C as z
};
//# sourceMappingURL=zod-error-response-DPpXG_M9.mjs.map
